import Cookies from 'js-cookie'

var loginTypeName: any = ''
var from: any = ''
const refresh = () => {
    loginTypeName = localStorage.getItem('loginTypeName')
    if (loginTypeName == 'chatlibrary') {
        from = 'chat'
    } else if (loginTypeName == 'xuanniao') {
        from = 'xuanniao'
    } else if (loginTypeName == 'chatmed') {
        from = 'chatmed'
    } else if (loginTypeName == 'chatpubliclibrary') {
        from = 'chatpubliclibrary'
    } else if (loginTypeName == 'chatpub') {
        from = 'chatPub'
    } else {
        from = 'none'
    }
}

export const setCookie = (name: string, value: string, prod: boolean = false) => {
    refresh()
    var fromname = from + name
    if (prod) {
        if (window.location.origin.indexOf('test') > -1 || window.location.origin.indexOf('192') > -1) {
            var newname = 'test_' + fromname
            Cookies.set(newname, value, { domain: '.newacademic.net' })
        } else {
            Cookies.set(fromname, value, { domain: '.newacademic.net' })
        }
    } else {
        Cookies.set(fromname, value)
    }
}

export const getCookie = (name: string) => {
    refresh()
    var fromname = from + name
    if (window.location.origin.indexOf('test') > -1 || window.location.origin.indexOf('192') > -1) {
        var newname = 'test_' + fromname
        return Cookies.get(newname)
    } else {
        return Cookies.get(fromname)
    }
}

export const removeCookie = (name: string) => {
    refresh()
    var fromname = from + name
    if (window.location.origin.indexOf('test') > -1 || window.location.origin.indexOf('192') > -1) {
        var newname = 'test_' + fromname
        Cookies.remove(newname)
    } else {
        Cookies.remove(fromname)
    }
}

export const clearAllCookie = () => {
    refresh()
    if (window.location.origin.indexOf('test') > -1 || window.location.origin.indexOf('192') > -1) {
        Cookies.remove('test_' + from + 'UserInfo',{domain: '.newacademic.net'})
        Cookies.remove('test_' + from + 'Token',{domain: '.newacademic.net'})
    } else {
        Cookies.remove(from + 'UserInfo',{domain: '.newacademic.net'})
        Cookies.remove(from + 'Token',{domain: '.newacademic.net'})
    }
}
